import { render, staticRenderFns } from "./payText.vue?vue&type=template&id=b5ddd0b2&scoped=true&"
import script from "./payText.vue?vue&type=script&lang=js&"
export * from "./payText.vue?vue&type=script&lang=js&"
import style0 from "./payText.vue?vue&type=style&index=0&id=b5ddd0b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ddd0b2",
  null
  
)

export default component.exports